import { useClient } from '@/composables/useClient'
import {
  DogBreedDto,
  DogDto,
  DogFoodAllergenDto,
  DogFoodTypeDto,
  DogHealthIssueDto,
  UpdateDogBody,
} from '@lyka-pet-food/contracts'

export const useDogs = () => {
  const getDogs = async (): Promise<{
    error?: string | null
    returnedDogs?: DogDto[]
  }> => {
    const client = await useClient()
    const { status, body } = await client.animals.getDogs()

    let error = null
    if (status == 500) {
      error = body.error
      return { error }
    } else if (status == 200) {
      return { returnedDogs: body }
    }

    return { error: 'Unspecified server error' }
  }

  const getDogsData = async (): Promise<{
    error?: string | null
    data?: {
      breeds: DogBreedDto[]
      healthIssues: DogHealthIssueDto[]
      foodTypes: DogFoodTypeDto[]
      foodAllergens: DogFoodAllergenDto[]
    }
  }> => {
    const client = await useClient()
    const { status, body } = await client.animals.getDogsData()

    let error = null
    if (status == 500) {
      error = body.error
      return { error }
    } else if (status == 200) {
      return { data: body }
    }

    return { error: 'Unspecified server error' }
  }

  const updateDog = async (id: string, dog: UpdateDogBody) => {
    const client = await useClient()
    const { status, body } = await client.animals.updateDog({
      body: {
        dog,
      },
      params: {
        id,
      },
    })

    let error = null
    if (status == 500) {
      error = body.error
      return { error }
    } else if (status == 200) {
      return { success: true, data: body }
    }

    return { error: 'Unspecified server error' }
  }

  return {
    updateDog,
    getDogs,
    getDogsData,
  }
}
